/**
 * @vuepress
 * ---
 * title: Purchase Tracking Report
 */

import Transformer from '../transformer'
import { attachMissingCurrentTime } from '@/utils/moment'
import { parentPrefixTransformer } from '@/transformers/utils'

const conceptTransform = ({
  description,
  id,
  kind,
  quantity,
  total,
  unit_price: unitPrice
}) => {
  return {
    description,
    id,
    kind,
    quantity,
    total,
    unitPrice
  }
}
const freightTransform = ({
  id,
  amount,
  drag_guide: dragGuide,
  freight_provider: freightProvider,
  freight_provider_id: freightProviderId,
  comment
}) => {
  return {
    id,
    freightProvider,
    freightProviderId,
    dragGuide,
    amount,
    comment
  }
}

const requisitionTransform = ({
  date_requisition: dateRequisition,
  folio,
  tentative_delivery_date: tentativeDeliveryDate,
  id
}) => {
  return {
    dateRequisition,
    folio,
    tentativeDeliveryDate,
    id
  }
}

class sinisterTransformer extends Transformer {
  static fetch({
    actual_delivery_days: actualDeliveryDays,
    estimated_delivery_date: estimatedDeliveryDate,
    business_unit: businessUnit,
    collection_date: collectionDate,
    concepts = [],
    cost_without_vat: costWithoutVat,
    customer,
    days_rec_supervisor: daysRecSupervisor,
    delivery_days: deliveryDays,
    discount_without_vat: discountWithoutVat,
    division_name: divisionName,
    freights = [],
    notification_date: notificationDate,
    oc_status: ocStatus,
    status,
    oldest_payment_date: oldestPaymentDate,
    provider_name: providerName,
    provider_number: providerNumber,
    purchase_order_id: purchaseOrderId,
    sinister_number: sinisterNumber,
    sinister_slug: sinisterSlug,
    sinister_status: sinisterStatus,
    supervisor,
    date_oc: dateOC,
    invoice,
    requisition,
    folio,
    oc_is_return: isReturn,
    oc_folio: ocFolio,
    amount_total: amountTotal,
    amount_without_vat: amountWithoutVat
  }) {
    return {
      actualDeliveryDays: +actualDeliveryDays,
      amountTotal,
      amountWithoutVat,
      estimatedDeliveryDate,
      businessUnit,
      collectionDate,
      costWithoutVat,
      customer,
      daysRecSupervisor: +daysRecSupervisor,
      deliveryDays: +deliveryDays,
      discountWithoutVat,
      divisionName,
      notificationDate,
      ocStatus: ocStatus || status,
      oldestPaymentDate,
      providerName,
      purchaseOrderId,
      sinisterNumber,
      sinisterSlug,
      sinisterStatus,
      supervisor,
      dateOC,
      concepts: concepts.length ? concepts.map((c) => conceptTransform(c)) : [],
      freights: freights.length ? freights.map((f) => typeof f !== 'number' ? freightTransform(f) : f) : [],
      invoice,
      folio: ocFolio || folio,
      isReturn,

      ...parentPrefixTransformer('requisition', requisition ? requisitionTransform(requisition) : {})
    }
  }

  static send({
    notificationDate,
    notificationComment,
    deliveryDays,
    collectionDate,
    status,
    isReturn,
    returnReason
  }) {
    return {
      notification_date: attachMissingCurrentTime(notificationDate),
      delivery_days: deliveryDays || deliveryDays === null || deliveryDays === undefined ? +deliveryDays : undefined,
      status,
      is_return: !!isReturn,
      collection_date: !isReturn ? attachMissingCurrentTime(collectionDate) : undefined,
      return_reason: returnReason,
      notification_comment: notificationDate ? notificationComment : null
    }
  }
}
export default sinisterTransformer
